import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { useHistory, Link } from "react-router-dom";
import "./negotiate-contract.view.css";
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonHLPure,
  HeaderHLPure,
  DialogSystemGLPure,
  BoxSomeHeadersGLPure,
  GridSimpleReadHLPure,
  ChatBoxGLPure,
} from "../../pures";

import PdfReader from "../../pures/adobePfdReader/PdfReader";
import { ClientContractService, WorkflowService } from "../../../services";
import FollowUpConfigurationsView from "../follow-up-actions-contracts/follow-up-actions-contracts-configuration.view";
import { Tooltip } from "@progress/kendo-react-tooltip";

/*  Sustituir despues Brayan Salas - 11:37 am 10 Feb 2023 */
import {
  disable,
  bussiness,
  iconTemplateSet,
  iconTemplateUnset,
  newProfileIcon,
  EditarDocumento,
} from "../../../assets/logos/icons";
/*  Sustituir despues Brayan Salas - 11:37 am 10 Feb 2023 */

import { TeamNegotiationAction } from "../../actions";
import { sliceString100AndAddPoints } from "../../../utils";

const NegotiateContractView = (props) => {
  const {
    clientContractId,
    loading,
    status,
    contract,
    showLoadingRequesting,
    toggleLoadingRequesting,
    showCompletedRequesting,
    toggleCompletedRequesting,
    showErrorRequesting,
    toggleErrorRequesting,
    showWarningRequesting,
    toggleWarningRequesting,
    workflowExecutionInfo,
    token,
    user,
    workflowExecutionId,
    message,
    createMessage,
    usersChat,
    conversation,
    membersChat,
    changesContract,
    membersWorkflow
  } = props

  const { t } = useTranslation();
  let history = useHistory();

  const url = process.env.REACT_APP_MIFIRMA_API;
  const workflowService = new WorkflowService(url);
  const clientContractService = new ClientContractService(url);
  const ENV = process.env;
  const mobileResolution = useMediaQuery("(max-width:660px)");

  const [messageDiscussion, setMessageDiscussion] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [urlPdf, setUrlPdf] = useState("")
  const [questionsAnswered, setQuestionsAnswered] = useState([])
  const [contractName, setContractName] = useState('')
  const [contractorName, setContractorName] = useState('')
  const [solicitudDate, setSollicitudDate] = useState('')
  const [contractorsName, setContractorsName] = useState('')
  const [headerTitle, setHeaderTitle] = useState('')
  const [urlDocs, setUrlDocs] = useState('')
  const [nameBtnNext, setNameBtnNext] = useState('')
  const [nameBtnBack, setNameBtnBack] = useState('')
  const [styleBtnBack, setStyleBtnBack] = useState({})
  const [styleBtnNext, setStyleBtnNext] = useState({})
  const [filePdf, setFilePDF] = useState({})
  const [takeGrid, setTakeGrid] = useState(5)
  const [userChange, setUserChange] = useState({})
  const [changeContractShow, setChangeContractShow] = useState([])
  const [userHasTrackChanges, setUserHasTrackChanges] = useState(false)
  const [numTeamMembers, setNumTeamMembers] = useState(-1);
  const [errorMissingMembers, setErrorMissingMembers] = useState(false);
  const [statusCurrent, setStatusCurrent] = useState(0)
  const [isPrimaryBackbtn, setIsPrimaryBackbtn] = useState(false)

  //renderiza el pdf y guarda la informacion en una variable para evitar que se actualice el pdfRender cuando se actuaiza el estado
  const pdf = useMemo(
    () => <PdfReader className="pdfReader" url={urlPdf} awsURL />,
    [urlPdf]
  );

  const takeGridNumber = changesContract.length

  const containerColumn3 = {
    display: "grid",
    justifyItems: "end",
    paddingRight: "10px",
  };

  const containerColumnMobile3 = {
    paddingRight: "0px",
  };

  useEffect(() => {
    if (
      workflowExecutionInfo &&
      workflowExecutionInfo.workflowStatusDescriptions
    ) {
      let { statusBack } = workflowExecutionInfo.workflowStatusDescriptions;
      let { statusCurrent } = workflowExecutionInfo.workflowStatusDescriptions;
      let { statusNext } = workflowExecutionInfo.workflowStatusDescriptions;

      let styleBackBtn = {
        display: statusBack && Number(statusBack.status) > 0 ? "block" : "none",
      };
      let styleNextBtn = {
        display: statusNext && Number(statusNext.status) > 0 ? "block" : "none",
      };
      let header = `${t("negotiateContractView.header.title")} ${statusCurrent.name
        }`;

      let titleBtnNext = `${statusNext.name}`;
      let titleBtnBack = `${statusBack.name}`;
      setHeaderTitle(header);
      setNameBtnBack(titleBtnBack);
      setNameBtnNext(titleBtnNext);
      setStyleBtnBack(styleBackBtn);
      setStatusCurrent(statusCurrent.status);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowExecutionInfo]);

  useEffect(() => {
    if (contract && contract.contractors) {
      let contractors = "";
      setContractName(contract.name);
      setContractorName(contract.user.email);
      setSollicitudDate(contract.createdDate);
      for (let index = 0; index < contract.contractors.length; index++) {
        let nameContract = contract.contractors[index].contractor.name;
        if (index === 0) {
          contractors = `${nameContract}`;
        } else {
          contractors = `${contractors}, ${nameContract}`;
        }
      }
      setContractorsName(contractors);
      let header = `${t("negotiateContractView.header.title")} Generación`;
      setHeaderTitle(header);
      toggleLoadingRequesting(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract]);

  useEffect(() => {
    let urlContract =
      contract &&
        contract.updatedDocumentPathPdf &&
        contract.updatedDocumentPathPdf !== "" &&
        contract.updatedDocumentPathPdf !== null &&
        contract.updatedDocumentPathPdf !== undefined
        ? contract.updatedDocumentPathPdf
        : contract.originalDocumentPathPdf;
    let urlContractDocs =
      contract &&
        contract.updatedDocumentPathWord &&
        contract.updatedDocumentPathWord !== "" &&
        contract.updatedDocumentPathWord !== null &&
        contract.updatedDocumentPathWord !== undefined
        ? contract.updatedDocumentPathWord
        : contract.originalDocumentPathWord;
    setUrlPdf(urlContract);
    setUrlDocs(urlContractDocs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, contract]);


  useEffect(() => {
    if (!changesContract || changesContract.length === 0) return;
    let allChanges = []
    changesContract.map((change) => {
      let userChange = {}

      if (change.text.length >= 100) {
        const newText = sliceString100AndAddPoints(change.text)
        userChange.change = newText
      } else {
        userChange.change = change.text
      }

      userChange.name = change.userName
      userChange.image = change.user.profilePicture
      userChange.date = change && change.createdDate ? change.createdDate : ''
      userChange.fieldSubtitle = ""
      switch (change.changeAccepted) {
        case "pending":
          userChange.status = 'Propuesta'
          break;
        case "accepted":
          userChange.status = 'Aceptada'
          break;
        case "rejected":
          userChange.status = 'Rechazada'
          break;
        default:
          userChange.status = 'Propuesta'
          break;
      }

      switch (change.type) {
        case "Insertion":
          userChange.action = "Agregó"
          break;
        case "Deletion":
          userChange.action = "Eliminó"
          break;
        default:
          userChange.action = "Agregó"
          break;
      }
      allChanges.push(userChange)
      return change
    })
    setChangeContractShow(allChanges)
  }, [changesContract])

  useEffect(() => {
    if (!user || !user.userMetaData || !membersWorkflow || membersWorkflow.length === 0) return
    let emailUser = user.userMetaData.userA3Cloud.email
    let memberGenerator = membersWorkflow.find((member) => member.email === emailUser && member.acceptRevisions === true)
    let styleNextBtn = {};
    if (!memberGenerator) {
      styleNextBtn.display = "none"
      setIsPrimaryBackbtn(true)
    } else {
      styleNextBtn.display = "block"
    }

    setStyleBtnNext(styleNextBtn)
  }, [membersWorkflow, user])


  const handleInputMessageDiscussion = (e) => {
    setMessageDiscussion(e.target.value);
  };

  const backButton = () => {
    history.goBack();
  };

  const handleBtnDiscussion = () => {
    setNameComponentUser("Discusion");
    setShowDetails(true);
  };

  const handleBtnConsultQuestionnaire515 = () => {
    setNameComponentUser("Consultar cuestionario");
    setShowDetails(true);
  };

  const handleRequestContract525 = () => {
    setNameComponentUser("Consultar contrato");
    setShowDetails(true);
  };

  const verifyIfUserHasTrackChanges = async () => {
    toggleLoadingRequesting(true);
    let hasTrackChanges = await workflowService.getMemberAcceptRevisions(
      workflowExecutionId,
      JSON.parse(localStorage.getItem("user")).userMetaData.userMifirma.email,
      token
    );
    if (hasTrackChanges.statusCode !== 200)
      throw new Error(
        "Ocurrió un error al tratar de ingresar a editar documento"
      );

    setUserHasTrackChanges(hasTrackChanges.data.userHasTrackChanges)

    return hasTrackChanges.data.userHasTrackChanges
  }

  useEffect(() => {
    if (token) {
      verifyIfUserHasTrackChanges()
    }
  }, [token])

  const handleEdit = async () => {
    toggleLoadingRequesting(true);
    try {
      let clientContract = await clientContractService.isOpenClientContract(clientContractId, token)
      if (clientContract.isOpen) {
        throw new Error("El contrato está siendo editado por otra persona, por favor espere");
      } else {
        await clientContractService.setIsOpenClientContract(Number(clientContractId), true, token)
      }

      history.push({
        pathname: `/edit-docx/${clientContractId}`,
        state: { trackChangesGovo: true, type: 'inboxTypeNegotiation', userHasTrackChanges, workflowExecutionId }
      });
    } catch (e) {
      toggleLoadingRequesting(false);
      await toggleWarningRequesting(true, e.message);
      setTimeout(() => {
        toggleWarningRequesting(false);
      }, 3000);
    }
  };

  //function to send next status
  const handleNextStatus = async () => {
    let messageError = "";
    let functionOk = true;

    try {
      if (
        Number(status) ===
        Number(ENV.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102605)
      ) {
        if (numTeamMembers < 0) {
          toggleWarningRequesting(true, "Debes agregar un grupo de negociantes");
          return;
        } else if (numTeamMembers === 0) {
          setErrorMissingMembers(true);
          return;
        }
        toggleLoadingRequesting(true);

        // Team negotiation screen
        let responseGenerateTeam =
          await workflowService.generateTeamNegotiation(
            workflowExecutionId,
            token
          );

        if (Number(responseGenerateTeam.statusCode) !== 200) {
          messageError = "No se pudo generar el equipo de negociación";
          throw new Error(messageError);
        }
        await workflowService.setMemberAcceptRevisions(
          workflowExecutionId,
          JSON.parse(localStorage.getItem("user")).userMetaData.userMifirma
            .email,
          token
        );
      } else if (Number(status) ===
        Number(ENV.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102610)) {
        toggleLoadingRequesting(true);

        if (!userHasTrackChanges) {
          messageError = "Sólo la persona que inició la negociación puede enviar a negociado el contrato.";
          throw new Error(messageError);
        }

        if (changesContract.length !== 0) {
          let existsPendingChange = changesContract.filter((changeContract) => changeContract.changeAccepted === 'pending')

          if (existsPendingChange.length !== 0) {
            messageError = "Aún quedan revisiones por aceptar o rechazar.";
            throw new Error(messageError);
          }
        }
      }

      // if(functionOk === false){
      //   throw new Error('Ocurrio un error')
      // }

      let workflowExecutionActionId = 3;
      //change status workflow to send next status
      let workflowChange = await workflowService.changeStatusWorkflow(
        workflowExecutionId,
        workflowExecutionActionId,
        token
      );
      if (
        workflowChange &&
        workflowChange.data &&
        Number(workflowChange.statusCode) === 200
      ) {
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          toggleCompletedRequesting(false);
          history.push("/");
        }, 3000);
      } else {
        messageError = "Error al ejecutar el servicio de workflow";
        throw new Error(messageError);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      await toggleErrorRequesting(true, messageError);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  //function to send status back
  const handleBackBtn = async () => {
    toggleLoadingRequesting(true);
    try {
      let workflowExecutionActionId = 4;
      //change status workflow to back status
      let workflowChange = await workflowService.changeStatusWorkflow(
        workflowExecutionId,
        workflowExecutionActionId,
        token
      );
      if (
        workflowChange &&
        workflowChange.data &&
        Number(workflowChange.statusCode) === 200
      ) {
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          toggleCompletedRequesting(false);
          history.push("/");
        }, 3000);
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 3000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  const handleInputChange = (e) => {
    let file = e.target.files[0];
    setFilePDF(file);
    let reader = new FileReader();
  };


  return (
    <div className="standard-wrapper">
      <div className="negotiateContractView-wrapper">
        {loading ? (
          <SimpleLoading />
        ) : (
          <Container
            lg={12}
            md={12}
            spacing={4}
            className="negotiateContractView-container"
          >
            <DialogSystemGLPure
              toggleLoadingRequesting={toggleLoadingRequesting}
              showLoadingRequesting={showLoadingRequesting}
              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
              toggleErrorRequesting={toggleErrorRequesting}
              showErrorRequesting={showErrorRequesting}
              toggleWarningRequesting={toggleWarningRequesting}
              showWarningRequesting={showWarningRequesting}
              message={message}
            />
            <div className="negotiateContractView-title-cotainer">
              <HeaderHLPure title={headerTitle} />
            </div>
            {showDetails && nameComponentUser ? (
              <FollowUpConfigurationsView
                nameComponentUser={nameComponentUser}
                hideShowDetails={() => {
                  setShowDetails(false);
                  setNameComponentUser("");
                }}
                setShowDetails={setShowDetails}
                setNameComponentUser={setNameComponentUser}
                status={status}
                setUrlPdf={setUrlPdf}
                setQuestionsAnswered={setQuestionsAnswered}
                {...props}
                conversation={conversation}
                usersChat={usersChat}
                handleInputChange={handleInputChange}
                createMessage={createMessage}
              />
            ) : (
              <>
                <Grid
                  container
                  className="negotiateContractView-body"
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                >
                  {Number(status) ===
                    Number(ENV.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102605) ? (
                    <TeamNegotiationAction
                      workflowExecutionId={workflowExecutionId}
                      setNumTeamMembers={setNumTeamMembers}
                      setErrorMissingMembers={setErrorMissingMembers}
                      errorMissingMembers={errorMissingMembers}
                    />
                  ) : Number(status) ===
                    Number(ENV.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102610) ? (
                    <>
                      <BoxSomeHeadersGLPure
                        titleOne={t("followUpActionsContractsView.contract")}
                        subtitleOne={contractName}
                        titleTwo={t("followUpActionsContractsView.solicitante")}
                        subtitleTwo={contractorName}
                        titleThree={t(
                          "followUpActionsContractsView.date.request"
                        )}
                        subtitleThree={solicitudDate}
                        titleFour={t(
                          "followUpActionsContractsView.companys.contractor"
                        )}
                        subtitleFour={contractorsName}
                      />
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="negotiateContractView-cards-container"
                      >
                        <div className="negotiateContractView-left-container">
                          <div className="negotiateContractView-grid-container">
                            <GridSimpleReadHLPure
                              dataGrid={changeContractShow}
                              skip={0}
                              take={takeGridNumber}
                              onSelectedItem={setUserChange}
                              titleRow1={t("negotiation_contract.view.grid.userAndChange")}
                              fieldImg={"image"}
                              fieldRow1={"name"}
                              textSubtitle={"change"}
                              fieldSubtitle={"fieldSubtitle"}
                              column2Status={false}
                              columnThree={true}
                              titleRow3={t("negotiation_contract.view.grid.details")}
                              fieldRow3={"action"}
                              textSubtitleColumn3={"date"}
                              textStyleColumn3={"status"}
                              filter={false}
                              iconAvatar={true}
                              containerColumn3={containerColumn3}
                              containerColumnMobile3={containerColumnMobile3}
                            />
                          </div>
                          <div className="negotiateContractView-card-discussion">
                            <Grid className="negotiateContractView-headerUsersChat">
                              <span className="negotiateContractView-titleGrid">
                                {t("negotiateContractView.team")}
                              </span>
                              <div className="negotiateContractView-containersAvatars">
                                {membersChat.map((item, index) => (
                                  <div>
                                    <Tooltip
                                      openDelay={600}
                                      position="bottom"
                                      anchorElement="target"
                                      tooltipClassName="tooltipGeneralStyle"
                                    >
                                      <div>
                                        <img
                                          title={item.name}
                                          key={index}
                                          src={
                                            item.avatarUrl &&
                                              item.avatarUrl !== ""
                                              ? item.avatarUrl
                                              : newProfileIcon
                                          }
                                          className="negotiateContractView-avatar"
                                          alt={item.name}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                ))}
                              </div>
                            </Grid>
                            <ChatBoxGLPure
                              user={usersChat}
                              conversation={conversation}
                              widthChat={1200}
                              heightChat={300}
                              // placeholderChat={"Escribe algo"}
                              handleInputChange={handleInputChange}
                              createMessage={createMessage}
                            />
                          </div>
                        </div>
                        <div className="negotiateContractView-right-container">
                          <div className="negotiateContractView-edit-document-container">
                            <div className="negotiateContractView-container-text-edit">
                              <p>
                                {t("negotiateContractView.description.1")} <br />{" "}
                                {t("negotiateContractView.description.2")}{" "}
                              </p>
                            </div>
                            <div
                              className="negotiateContractView-div-edit"
                              onClick={handleEdit}
                            >
                              <img
                                alt="editDocument"
                                className=""
                                src={EditarDocumento}
                                width="50px"
                              ></img>
                              <div className="negotiateContractView-label-btn-edit">
                                <h5>
                                  {t("followUpActionsContractsView-edit-docx")}
                                </h5>
                              </div>
                            </div>
                          </div>
                          <div className="negotiateContractView-template-container">
                            {pdf}
                          </div>
                        </div>
                      </Grid>
                    </>
                  ) : null}
                  <div className="negotiateContractView-btns-container">
                    <div className="negotiateContractView-secondary-btns">
                      <Link to="/">
                        <ButtonHLPure
                          nameBtn={t("followUpActionsContractsView.button.exit")}
                          primary={isPrimaryBackbtn}
                        />
                      </Link>
                    </div>
                    <div className="" style={styleBtnNext}>
                      <ButtonHLPure
                        nameBtn={nameBtnNext}
                        primary={true}
                        onClickBtn={(e) => handleNextStatus(e)}
                      />
                    </div>
                  </div>
                </Grid>
              </>
            )}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <PromotionalFooterPure />
            </Grid>
          </Container>
        )}
      </div>
    </div>
  );
};

export default NegotiateContractView;
